import type {PropsWithChildren} from 'react';

import styles from './styles.module.css';

export function Icon(props: PropsWithChildren<unknown>) {
    return (
        <div role='img' className={styles.iconContainer}>
            {props.children}
        </div>
    );
}
